import React from "react";
import { Layout, Typography, Image } from "antd";
import CommonSidebar from "../components/CommonSidebar";
import partnersImage from "../assets/focus.jpg";

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const PartnershipsPage = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ background: "#fff" }}>
        {/* Sidebar */}
        <CommonSidebar defaultSelectedKey="6" />

        {/* Main Content */}
        <Layout
          style={{
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            padding: "20px 20px",
            flex: 1, 
          }}
        >
          <Content
            style={{
              width: "100%",
              maxWidth: "100%", 
            }}
          >
            {/* Image Section */}
            <div style={{ textAlign: "left", marginBottom: "30px" }}>
              <Image
                src={partnersImage}
                alt="Partnerships"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                }}
                preview={false}
              />
            </div>

            {/* Text Section */}
            <Typography>
              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                At <strong>Yalla Nellab</strong>, we believe lasting impact is
                built through collaboration. While our journey has begun
                independently, we are actively seeking partnerships with
                organizations, schools, brands and community groups that share
                our vision — to make sport accessible, inclusive and
                transformative for everyone.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                We welcome future partners who are passionate about youth
                development, community engagement and the power of sport to
                bring people together. Whether through sponsorships, co-hosted
                events, or shared initiatives, our goal is to build alliances
                that create real change — on and off the field.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                Together, we can inspire communities, empower individuals and
                build a world where everyone has the opportunity to play, grow
                and thrive.
              </Paragraph>
            </Typography>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default PartnershipsPage;